<template>
	<div>
			
			<div class="commonBox">
				<div>
					<div id="reviewList">
						<ul>
							<li v-for="row in listData">
								<div class="profile">
									<img src="@/assets/img/review_profile_kmong.png">
								</div>
								<div class="user">
									<p class="name">{{ row.buyer_username }}님</p>
									<p class="rate">
										<img src="@/assets/img/icon_star.svg">
										{{ row.rate.toFixed(1) }} | 작업일 : {{ row.order.days }}
									</p>
									<p class="date">{{ row.replied_at }}</p>
								</div>
								<div class="info">
									<p class="contents" v-html="row.message"></p>
								</div>
							</li>
						</ul>

						<div class="btnBox">
							<button type="button" @click="listGet()" v-if="listBtnShow">
								<img src="@/assets/img/icon_plus.svg">
							</button>
						</div>
					</div>
				</div>
			</div>
		
	</div>
</template>

<style>
	#reviewList { width: 100%; float: left; }
	#reviewList > ul { width: 100%; float: left; }
	#reviewList > ul > li { width: 100%; float: left; padding: 20px; margin-bottom: 20px; display: table; table-layout: fixed; border: 1px solid #DDD; color: #000; }
	#reviewList > ul > li > div { display: table-cell; vertical-align: top; }
	#reviewList > ul > li > div > p { width: 100%; float: left; }
	#reviewList > ul > li > .profile { width: 50px; vertical-align: middle; }
	#reviewList > ul > li > .profile > img { width: 100%; }
	#reviewList > ul > li > .user { width: 200px; padding-left: 10px; vertical-align: middle; }
	#reviewList > ul > li > .user > .name { font-size: 12px; font-weight: 500; letter-spacing: 0px; }
	#reviewList > ul > li > .user > .rate { font-size: 11px; font-weight: 400; letter-spacing: 0px; margin-top: 2px; color: #333; }
	#reviewList > ul > li > .user > .rate > img { height: 10px; top: -2px; }
	#reviewList > ul > li > .user > .date { font-size: 11px; font-weight: 400; margin-top: 10px; color: #666; }
	#reviewList > ul > li > .info > p.contents { font-size: 13px; font-weight: 400; word-break: keep-all; line-height: 21px; }
	
	#reviewList > .btnBox { width: 100%; float: left; text-align: center; }
	#reviewList > .btnBox > button { width: 60px; transition: transform 0.5s; background: none; transform: rotate(0deg); }
	
	@media (hover : hover){
		#reviewList > .btnBox > button:hover { transform: rotate(180deg); }
	}
	
	@media (max-width: 700px){
		#reviewList > ul > li { padding: 20px; margin-bottom: 10px; display: block; }
		#reviewList > ul > li > div { width: 100%; float: left; display: block; }
		#reviewList > ul > li > div > p { width: auto; margin-top: 0 !important; }
		#reviewList > ul > li > .profile { width: 30px; }
		#reviewList > ul > li > .user { width: calc(100% - 50px); }
		#reviewList > ul > li > .user > .name { font-size: 11px; margin-right: 10px; }
		#reviewList > ul > li > .user > .date { width: 100%; margin-top: 3px !important; }
		#reviewList > ul > li > .info { margin-top: 10px; }
		
		#reviewList > .btnBox { margin-top: 10px; }
		#reviewList > .btnBox > button { width: 50px; }
	}
</style>

<script>
	var $;
	
	export default {
		name : "review",
		data : function(){
			return {
				listData : [],
				listPage : 1,
				listBtnShow : true,
				topVisualTitle : "개발평가",
				topVisualSub : "일삼사삼사공에서 이루어드린 꿈 개발평가들입니다."
			}
		},
		methods : {
			pageLoad : function(){
				$ = this;
				
				$.listData = [];
				
				var frmData = new FormData();
				frmData.append("page", $.listPage);
				$.$parent.coverShow = true;
				
				$.$axios.post("//api.134340.kr/review/list", frmData, { headers: $.$axiosHeader }).then(function(res){
					for(var i = 0; i < res.data.data.length; i++){
						res.data.data[i].message = res.data.data[i].message.replace(/(?:\r\n|\r|\n)/g, "<br />");
						
						$.listData.push(res.data.data[i]);
					}
					
					$.listPage++;
					frmData.append("page", $.listPage);
					$.$axios.post("//api.134340.kr/review/list", frmData, { headers: $.$axiosHeader }).then(function(res){
						for(var i = 0; i < res.data.data.length; i++){
							res.data.data[i].message = res.data.data[i].message.replace(/(?:\r\n|\r|\n)/g, "<br />");

							$.listData.push(res.data.data[i]);
						}

						$.$parent.pageOpen();
						$.$parent.topVisualTitle = $.topVisualTitle;
						$.$parent.topVisualSub = $.topVisualSub;
						
						setTimeout(function(){
							$.$parent.coverShow = false;
						}, 500);
					});
				});
			},
			listGet : function(){
				$.$parent.coverShow = true;
				
				$.listPage++;
				
				var frmData = new FormData();
				frmData.append("page", $.listPage);
				
				$.$axios.post("//api.134340.kr/review/list", frmData, { headers: $.$axiosHeader }).then(function(res){
					if(res.data.data){
						for(var i = 0; i < res.data.data.length; i++){
							res.data.data[i].message = res.data.data[i].message.replace(/(?:\r\n|\r|\n)/g, "<br />");

							$.listData.push(res.data.data[i]);
						}
					} else {
						$.listBtnShow = false;
					}
					
					$.$parent.coverShow = false;
				});
			}
		},
		mounted : function(){
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/review.vue